export const ActionIdMappingProd = {
  PUBLIC_ACTION_ID: 'PUBLIC_ACTION_ID',
  CREATE_UPDATE_SITE: 'cd601232-4074-4413-a936-85d15395ff86',
  CREATE_UPDATE_AREA: 'd7a6bb01-9f70-4889-b7cb-b5a3285e11df',
  CREATE_UPDATE_SHIFT: 'e27ebb96-17fa-4e08-8970-20c775d6bc2c',
  UPLOAD_ROSTER: '',
  DOWNLOAD_ROSTER: 'e8c2a2e6-495b-4fd5-a25e-58978d67f2d3',
  CREATE_HOLIDAY: '926abf33-05d8-4908-8790-c45e67abdfb6',
  CREATE_LEAVE: 'be7a52b5-e513-49f5-a1c2-757e3fd7999d',
  UPDATE_HOLIDAY: '9a2f10f5-16b4-4305-9494-1c0b7f83d7b5',
  UPDATE_LEAVE: '5d9f84cc-1462-4c62-b035-200e0ae7e07f',
  INITIATE_SEPARATION: 'a96090e0-0d6d-406c-97a4-173e0bcd3c2b',
  APPROVE_REJECT_LEAVE: '1ad83315-d20d-4de5-b8dc-54d0c4b7f521',
  APPROVE_REJECT_SEPARATION: 'ad5c729b-f89b-4427-803c-de4940092ebe',
  REQUEST_OT: '610678ed-4980-4268-a821-bf4c54e011db',
  CANCEL_OT: '6c4f27be-1f13-4291-b660-cf8a0c75e24d',
  ADD_TEAM_MEMBER: '8082121b-1aee-4feb-aa58-1339978aaf2c',
  APPROVE_BGV: 'b9eb4790-0810-437b-b496-6073d62ef238',
  GET_BGV_LIST_V2: '59d0897a-be09-4d82-aef0-58f9bd434a8a',
  DEBOARD_VENDOR: '13338f8d-43a2-4b0a-ac8c-399d79223438',
  ASSIGN_VENDOR_AND_JOB_ID: '622d251a-4afb-4c33-aa0f-0834bb40202a',
  WITHDRAW_APPLICATION: '10dea695-123e-4e6e-bd05-6978bf164f6a',
  VERIFY_CANDIDATE_ONBOARDING: '50e75d44-39dd-4bef-86df-68e747add0fb',
  REVIEW: '458906d1-396c-4038-9e87-ba68d818a5d1',
  VIEW_DOCUMENTS: 'c638c373-6426-4f17-bfb1-6d9ddd611790',
  REVIEW_DOCUMENTS_MANUALLY: '5a1b0b9b-67f0-410c-8d41-908fa6c86028',
  REVIEW_CANDIDATURE: 'adf697a7-edb4-41c5-8b1e-8d6e3f61ab6d',
  SCHEDULE_INTERVIEW: '7d3bcd74-e5b2-47fd-9ae2-ac86bedc3028',
  START_INTERVIEW: '9cbea482-f388-4130-b480-713ca8317af5',
  UPLOAD_OFFER_LETTER: '37c3ff3f-4ae9-4ea6-bdc7-9e651f899c43',
  VERIFY_ONBOARDING: 'b1943f61-0ca3-4032-94d0-9ba082523f52',
  EVALUATE_ONBOARDING: '13cb5a9b-8ba6-4057-a2ef-c0daae5f70e5',
  PUNCHIN_INREVIEW: '7cedf05d-a3e9-4783-abf7-2047bf98f892',
  PUNCH_OUT_REVIEW: '6a5a0482-ce49-4293-a69e-229ea120fc5e',
  BULK_PUNCHOUT_APPROVAL: '1d809b7f-2992-4a85-b08c-db671dc0dd6d',

  OT_APPROVALS_REVIEW: '89334dd3-614f-4a5b-b110-cd3d0af1a51e',
  TOPUP_REVIEW: 'cc796385-8182-46ef-bb37-81f1fb54fb43',
  REGULARISATION_REVIEW: '1ffcb406-c073-41ed-b4dd-65c7165bc569',
  SPOOF_REVIEW: '9f05c424-c24d-448e-ae9c-55c7466efee9',
  APPLICATION_JOURNEY: '',
  CONFIGURE_AREA: '',
  ACTIVITY_LOG: '',
  UPLOAD_DOCUMENTS: '',
  UPLOAD_REGULARISATION: '9f8dae49-ea27-42d4-a689-93362598cd60',
  UPLOAD_BULK_USER_CREATION: 'b3367294-fdb1-497a-b472-ae40ef487389',
  UPLOAD_BULK_GRACE_ATTENDANCE: '6ef97e67-74f3-4f5b-a606-f40e82873b6e',
  UPLOAD_BULK_ROLE_UPDATE: '086108df-fdac-4cfa-87b1-456742aa2c83',
  HOLD_REQUISTION: 'aaee0cf6-cf3a-4f39-8dd0-b9e60ab025b1',
  RESUME_REQUISTION: '0486ef65-a737-40cf-9e9b-c64e325a2191',
  CLOSE_REQUISTION: '6328017b-2a85-4486-803d-f290b909c858',
  EDIT_JOB_REQUISTION: '010d1456-09cd-4b84-ae16-f36d275ce10f',
  JOB_REQUISITION_ACTIVITY_LOG: '',
  SHARE_JOB_DETAILS: '37bd0e49-37c4-4bbc-bc06-9af4ee31a32f',
  REFER_LEAD_WITH_CSV: '820626a5-f55f-494e-a0ed-9736c51ee040',
  JOB_REQUISITION_ADD_CANIDATE: '',
  BULK_CREATE_JOB_REQUISITION: '1f47d94b-cd6a-444b-9805-f0c48670b176',
  ONBOARDING_REVIEW_DOCUMENTS_MANUALLY: 'd8ec62ff-5fb0-4a1c-ae25-ef08945a33d0',
  ONBOARDING_VIEW_DOCUMENTS: 'bb91d180-4608-4eaa-a6a2-43509630d7c8',
  ONBOARDING_VERIFY_BANK_UAN_DETAILS: '4c0f4252-25b5-4d33-ae57-43455a645e58',

  ONBOARDING_RETRY_LMS: '71eb97ed-acd5-47a5-9871-1ce54a20409b',
  ONBOARDING_RETRY_BGV: '71eb97ed-acd5-47a5-9871-1ce54a20409b',
  ONBOARDING_RETRY_THOR: '71eb97ed-acd5-47a5-9871-1ce54a20409b',
  CREATE_FLEX_SLOT: '1713f2bf-0f96-4efe-a809-4fffebe7f283',
  CREATE_FLEX_SITE: '6d0e1fbc-0130-4048-9d04-b0e3eea36f49',
  CANCEL_FLEX_SITE: '7265f136-1271-4ea9-9dd6-2c4ad9f1f926',
  UPLOAD_CSV_FOR_FLEX_SITE: 'fec30dad-0760-40e6-9d6e-4571d1e4fe07',
  DOWNLOAD_CSV_FOR_FLEX_SITE: 'b9303e96-81f9-4923-820d-c0702e337a35',
  EDIT_FLEX_SITE: '33f2813e-519f-4c0b-b170-51f5451ed906',
  VIEW_DETAIL_FLEX_SITE: '0fecc68b-2e8a-4d64-ba8a-295df845b7b9',
  APPROVAL_PAYSHEET_FLEX_PAYOUT: '4edc9815-eb5c-4613-84e4-c175cdd76f98',
  VENDOR_ONBOARDING: '8e983af3-f533-46bd-b641-9ff2e335c5db',
  UPDATE_TICKETS_BY_ID: 'd11902d2-223c-4d30-870f-ff67cb2c38f3',
  BULK_DOWNLOAD_GRIEVANCE_TICKET: '360c35b0-e5f7-43d3-83af-7e074c15e8cb',
  DOWNLOAD_ZIP_FILE_GRIEVANCE: '9402f4da-fe6c-409a-a0f0-2e650a6de3e7',
  CREATE_TEMPORARY_TRANSFER: 'dd280234-bb3a-406b-bd5a-23b2326c262a',
  CREATE_PERMANENT_TRANSFER: '785b1809-49a1-4a8a-8ae4-c734876af903',
  APPROVE_REJECT_TRANSFER: 'd017d443-073e-4d1c-b398-c636a0cdf359',

  EDIT_TEMPORARY_TRANSFER: '50e68ceb-34df-409e-bff7-9923fcbd2615',
  EDIT_PERMANENT_TRANSFER: '703ac3b8-9f8d-4f03-b8a7-b6b9cbf86f73',

  CANCEL_TEMPORARY_TRANSFER: 'ac1b13e4-fb8c-4aeb-9b14-6ed0c74fabf4',
  CANCEL_PERMANENT_TRANSFER: 'f7ece92a-1299-4e99-890c-9d2a1fbb3180',

  EDIT_EMPLOYEE_TEMPORARY_TRANSFER: '41f0fd82-ca45-4e11-ba34-336bdf52231f',
  EDIT_EMPLOYEE_PERMANENT_TRANSFER: 'ef86bfb6-046e-46ba-801c-1bf124b62d65',

  CANCEL_EMPLOYEE_TEMPORARY_TRANSFER: '0fe7990e-b725-4f8c-a467-88ead9f40fc8',
  CANCEL_EMPLOYEE_PERMANENT_TRANSFER: '6fe4dd7e-88ae-46ea-9001-6661ac1c83a8',
  UPDATE_EMPLOYEE_SHIFT_ROSTER: 'e8b2171e-89b0-43b4-b8a3-436249f2de5d',
  DOWNLOAD_CTC_MAPPING: 'eafc5a97-3c68-4b37-be0a-019d493beac2',
  UPDATE_CTC_MAPPING: '08970e48-4f02-43d0-b67e-2399b4db4295',
  BULK_PUNCHIN_APPROVAL: '8ea58b85-8187-4e36-8adc-bc5b33b462dc',
  VENDOR_PAYOUT_DOWNLOAD: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PROCESSED_PAYOUT_DOWNLOAD: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PROCESSED_PAYOUT_VIEW_DOWNLOAD: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  DOWNLOAD_PLAN: '2b9f2554-85c2-4963-8aee-4ec740b3ab2d',
  REQUEST_ROSTER_PLAN: '62e31e24-0e44-4b9b-b5ce-a92aa72b75cf',
  VIEW_ROSTER_ATTENDANCE_SUMMARY: '5e2a7107-fa47-47a8-8f9b-5dc531801615',
  VIEW_ROSTER_EMPLOYEE_DETAILS: '8736c7db-2e18-4e39-b38a-922779f484fe',

  REVIEW_ABSCONDING_REQUEST: '7912784b-37b1-491e-83e2-191abd736fa4',

  // Incentive Management Actions
  CREATE_INCENTIVE: 'b3425418-d387-4664-9007-736f3470b971',
  REVIEW_INCENTIVE: 'c07f68ec-ccff-4149-bfcf-ec8b58461ccb',
  UPDATE_INCENTIVE: '47e9f2b0-988b-4220-8703-bcf32ce5fb1a',
  MARK_INCENTIVE_INACTIVE: '00d726f1-b733-409c-ab20-50d10c5ffbc7',

  // Payroll actions
  PAYROLL_DOWNLOAD: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_UPLOAD: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_VIEW_HISTORY: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_FREEZE: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_DOWNLOAD_INVOICE: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_ACK_INVOICE: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_DOWNLOAD_PAYSHEET: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_ACK_UTR: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  PAYROLL_DOWNLOAD_UTR: '4bd7095c-fcdb-43cf-8b9c-a9afe589a72b',
  EDIT_OL_PRE_ONBOARDING_DETAILS: '630c3538-18d6-49a6-8cbe-ae143719b68a',
  BULK_DOWNLOAD_PRE_ONBOARDING: '4a7b8adf-3fd2-4d95-b766-88470560b285',
  UPLOAD_OFFER_LETTER_PRE_ONBOARDING: 'de0b6c87-55d2-447d-b641-e4b06e6bdc7b',

  // Flex Rate Card Management Actions
  CREATE_UPDATE_FLEX_RATE_CARD: 'a6f1b83c-32b9-44eb-9d80-1b27d39d6b27',
  VIEW_FLEX_RATE_CARD_LIST: '1745b941-b0d2-4710-8670-b02e14888f0b',
  DOWNLOAD_FLEX_RATE_CARD: '80c938b4-8429-4cd6-8e5e-5edb03825a29',
  UPLOAD_FLEX_UTR_SHEET: '45352091-02e5-4587-bbd7-a93316bfcbbd',
  UPDATE_FLEX_EARNINGS: 'e621d597-1221-4851-a016-a2890b2085f1',
  APPROVE_FLEX_EARNINGS: 'b581527e-20c6-4284-a77e-6c71b5d281c5',
  UPLOAD_PAYSHEET_EDGE: 'a06fd120-0455-488c-b033-1f245e57d4dd',
  UPLOAD_UTR_EDGE: '0ddf52cc-e950-4690-830a-b3d0cb4adf18',

  CREATE_EDIT_REFERRAL_RATE_CARD: '290272c8-78fe-4e48-a779-a1d2df7b690d',
  DOWNLOAD_REFERRAL_RATE_CARD: '2c716285-22ec-4214-b67f-1ebda39adfbe',

  // Addendum Management Actions
  VIEW_ADDENDUM_STATS: '0280d730-5293-41e3-96db-a581966ab415',
  VIEW_ADDENDUMS_LIST: 'bf2dd679-7298-4073-bb6c-ab3001c0b9ad',

  DOWNLOAD_RATE_CARD_MANAGEMENT: 'a1b49f2a-05ab-473d-bff8-2ff9058cfe1e',
  UPLOAD_RATE_CARD_MANAGEMENT: 'e30dcd9b-5d17-4816-939c-7601715ef320',
  CREATE_UPDATE_FT_RATE_CARD: '5aa344e5-ded0-42da-bc9e-6eecad9d1051',

  REVIEW_IT_REQUEST: 'd10ddf6c-7801-44e1-9dd5-6bb7310c666a',
  GET_IT_REVIEWS: 'a95a0430-f3c9-4b24-b530-7c75c5c73679',
  DOWNLOAD_IT_REVIEWS_REPORT: 'ae954551-8f4d-488b-8179-750aafd8a672',
  UPDATE_EMPLOYEE_ASSET: '352c4b43-f94a-4a29-bdd5-d287e2eeed49',
  GET_EMPLOYEE_ASSETS: 'ae74c8c6-3691-4765-997a-c59365c8eb10',

  UPLOAD_FT_FLEX_SLOTS: '107f29cf-e3dd-425a-9965-b29d6522827b',

  // Payout Processing - Internal
  ZPL_EDGE_ONGOING_PAYOUT_VIEW: '622494af-12cd-4be2-abdf-2c2dc7e31655',
  ZPL_EDGE_PROCESSED_PAYOUT_VIEW: '13e4300f-f0ba-4f6b-ae32-1cbeac1fa997',
  MH_ZPL_EDGE_ONGOING_PAYOUT_VIEW: '436740cf-961a-4a6c-bda8-36c6a14c8809',
  MH_ZPL_EDGE_PROCESSED_PAYOUT_VIEW: 'bb171b9a-2a4e-4fbe-8211-245e2307351a',
  ZPL_EDGE_UPDATE_PAYOUT_STATUS: '1d73d906-d835-409f-98ea-1610651c7bee',
  MH_ZPL_EDGE_UPDATE_PAYOUT_STATUS: 'bc94a068-0efc-4744-889c-cd23a87d7147',
  ZPL_EDGE_GET_PAYROLL_CYCLES: 'fbd261a2-eaf8-482b-8295-6a753e3a128a',
  MH_ZPL_EDGE_GET_PAYROLL_CYCLES: '99b2b402-f6b0-4b71-bc78-bda18a526b7d',

  REVIEW_POST_ONBOARDING_REQUEST: '48abbecd-9ac7-427c-a6de-11ab15cd0002',

  DOWNLOAD_HRMS_SHIKSHA_INTEREST_REPORT: '8caad793-f52c-4dcd-b33d-1672685151b5',

  GET_ROLE_CTC_SUMMARY: 'fd000f35-aa3a-4f21-b0b8-b47e907144fb',
};
